function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvideo = function SvgInvideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 76.4 75"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "invideo_svg__a",
    x1: 43.569,
    x2: 43.569,
    y1: 116,
    y2: 41,
    gradientTransform: "matrix(1 0 0 -1 0 116)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f33d5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#c51ea9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4f3ce4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 19.2C10.8 8.6 19.1 0 29.5 0c20.1 0 37.6 15.1 46.9 37.5C67.1 59.9 49.6 75 29.5 75c-10.4 0-18.8-8.6-18.8-19.2 0-8.6 5.5-15.9 13.1-18.3-7.5-2.5-13-9.7-13-18.3",
    style: {
      fill: "url(#invideo_svg__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 52.5c-6 0-10.8-3.4-10.8-7.7 0-3.4 3.2-6.3 7.6-7.3H38c-5.4 8.9-15.6 15-27.2 15",
    style: {
      fill: "#c51ea9"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "invideo_svg__b",
    x1: 37.944,
    x2: 0,
    y1: 86.002,
    y2: 86.002,
    gradientTransform: "matrix(1 0 0 -1 0 116)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c51ea9",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f33d5e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.8 22.5c-6 0-10.8 3.4-10.8 7.7 0 3.4 3.2 6.3 7.6 7.3H38c-5.4-9-15.6-15-27.2-15",
    style: {
      fill: "url(#invideo_svg__b)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "invideo_svg__c",
    x1: 45.054,
    x2: 45.054,
    y1: 78.506,
    y2: 60.131,
    gradientTransform: "matrix(1 0 0 -1 0 116)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f33d5e",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.7 55.9c-5.4 0-9.8-4.2-9.8-9.4 0-4.2 2.9-7.8 6.9-9h27.4c-4.9 11-14 18.4-24.5 18.4",
    style: {
      fill: "url(#invideo_svg__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2 30.1c2.1 0 3.8-1.7 3.8-3.8s-1.7-3.8-3.8-3.8-3.8 1.7-3.8 3.8 1.6 3.8 3.8 3.8",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#fff"
    }
  }));
};
export default SvgInvideo;